//
// PDF upload JS
// --------------------------------------------------
// see also...
// - handle_empathy_pdf_upload function in genesys-empathy-assessment.php
// - relevant hidden fields in includes/assessment/hidden-fields.php
// --------------------------------------------------

const wpAjaxUrl = document.querySelector('input[name="geaAjaxUrl"').value;
// console.log('wpAjaxUrl: ', wpAjaxUrl);

// this is a Wordpress nonce
const resultsId = document.querySelector('input[name="geaResultsId"').value;

// export let pdfUploadURL;
// end global vars

//
export async function uploadPdfWithWpAjax(fileName, pdfBlob) {
  const fileFormData = new FormData();

  // name of WP action / function
  fileFormData.append('action', 'handle_empathy_pdf_upload');
  // nonce
  fileFormData.append('geaResultsId', resultsId);
  // name of the PDF file
  fileFormData.append('fileName', fileName);
  // the actual BLOB
  fileFormData.append('pdfBlob', pdfBlob);

  return await fetchPostForPDFUpload(wpAjaxUrl, fileFormData);
}

async function fetchPostForPDFUpload(url, data) {
  return await fetch(url, {
    method: 'POST',
    body: data,
    cache: 'no-store',
  })
    .then((response) => {
      if (response.ok) return response;
      else
        throw Error(
          `Error: Server returned ${response.status}: ${response.statusText}`
        );
    })
    .then((response) => {
      return response.json();
    })
    .then((responseJSON) => {
      console.log('PDF upload response: ', responseJSON);
      // pdfUploadURL = responseJSON.pdfUrl;
      // console.log('pdfUploadURL: ', pdfUploadURL);
      return responseJSON.pdfUrl;
    })
    .catch((error) => {
      console.error('Error!', error);
      return 'Sorry. There has been an error with the PDF upload.';
    });
}
